import { render, staticRenderFns } from "./Managements.vue?vue&type=template&id=4731215e"
import script from "./Managements.vue?vue&type=script&lang=js"
export * from "./Managements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports